export default __webpack_public_path__ + "static/media/logo.5533114a.svg";